import type { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Text } from '@frontend/design-system';

export const Section = ({ heading, children }: { heading: string; children: ReactNode }) => {
  return (
    <section css={containerStyles}>
      <Text as='h4' weight='bold'>
        {heading}
      </Text>
      <div css={contentStyles}>{children}</div>
    </section>
  );
};

const containerStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-sm);
`;

const contentStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-space-gap-xs);
`;
